
import React, {useEffect, useState} from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {createsuscripcionop8hb } from '../../api/suscripcionop8hb.api'

import './errorqmpd1.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Perrorqmpd1 = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {



useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id690133698e5aed52dc82d2c4" >

      <div id="iw4j" className="">
      
      <div id="i6ssn" className="">
      
      <div id="imeimh" className="">
      
      <div id="isb2y2" className="">
      
      <div id="i6ztzg" className="">
      
      <img
        className=""
        id="ia8bbi"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh3jt9qt.png"
        alt="undefined"
      />
      
      </div>
      
        <a
          target="_blank"
          className=""
          id="iwrtu"
          href="mailto:info@example.com"
        >
          
    <div id="i06b9" className="">
    <>info@dicipgo.com</>
    </div>
    
        </a>
        
      <div id="iamrom" className="">
      
      <img
        className=""
        id="iywkvr"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhanptg4.png"
        alt="undefined"
      />
      
      </div>
      
        <a
          target="_blank"
          className=""
          id="i6ymq"
          href="tel:+21236547898"
        >
          
    <div id="ilrna" className="">
    <>+504 3334-8846</>
    </div>
    
        </a>
        
      <div id="ivz97" className="">
      
      <img
        className=""
        id="i8i7g"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhanna44.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="id9ue">
        <>Lunes - Viernes (08AM - 05PM)</>
      </div>
      
      </div>
      
      <div id="ib64js" className="">
      
      </div>
      
      <div id="ikqplk" className="">
      
      </div>
      
      <div id="i9tztf" className="">
      
      </div>
      
      <div id="igip6k" className="">
      
      </div>
      
      </div>
      
      <div id="i58lg7" className="">
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i0zkbr" className="">
      
      <div id="i0fboh" className="">
      
        <a
          target=""
          className=""
          id="iytouh"
          href={`/`}
        >
          
      <img
        className=""
        id="idepm2"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh3p0ayf.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      <div id="i76z8x" className="">
      
        <a
          target=""
          className=""
          id="idlxcg"
          href={`/`}
        >
          
    <div id="i7imp2" className="">
    <>INICIO</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ix0zc7"
          href={`/nosotros`}
        >
          
    <div id="i2vzcj" className="">
    <>CONÓCENOS</>
    </div>
    
        </a>
        
        <LoftyDropdownComponent
          id="im0qqv"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="ixwopc" className="gjs-dropdown-menu-trigger ">
<>ÚNETE</></div>

            </>
          }
          childrenHover={
            <>
              <div id="ihz1li" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="iojw0f"
          href={`/socio_motorista`}
        >
          
    <div id="id1tnc" className="">
    <>SOCIO MOTORISTA</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ibs9om"
          href={`/publicidad`}
        >
          
    <div id="ialxa1" className="">
    <>PUBLICIDAD</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <LoftyDropdownComponent
          id="ii4h1h"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="i687zt" className="gjs-dropdown-menu-trigger ">
<>POLÍTICAS</></div>

            </>
          }
          childrenHover={
            <>
              <div id="i8aj9g" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="iy44hw"
          href={`/terminos_politicas`}
        >
          
    <div id="ilmv8g" className="">
    <>TERMINOS & POLITICAS</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ikc7sg"
          href={`/eliminar_cuenta`}
        >
          
    <div id="ik8exo" className="">
    <>ELIMINAR CUENTA</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <LoftyDropdownComponent
          id="iief0t"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="icx7l1" className="gjs-dropdown-menu-trigger ">
<>RESPUESTAS</></div>

            </>
          }
          childrenHover={
            <>
              <div id="ixlphb" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="ie11fh"
          href={`/preguntas_respuestas`}
        >
          
    <div id="i5wol3" className="">
    <>PREGUNTAS</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="imdl75"
          href="#"
        >
          
    <div id="idim8j" className="">
    <>NOTICIAS !PRONTO!</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <a
          target=""
          className=""
          id="ianf7t"
          href={`/contactanos`}
        >
          
    <div id="i3870v" className="">
    <>CONTACTANOS</>
    </div>
    
        </a>
        
      </div>
      
      <div id="iacot" className="">
      
        <a
          target=""
          className=""
          id="ifr36q"
          href="https://api.whatsapp.com/send/?phone=33348846&text&type=phone_number&app_absent=0"
        >
          
      <img
        className=""
        id="i7lptj"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhanr6xa.png"
        alt="undefined"
      />
      
    <div id="" className="">
    <>Via WhatsApp</>
    </div>
    
        </a>
        
      <img
        className=""
        id="ilg8m"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh3k9u97.png"
        alt="undefined"
      />
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      </li>
      
        <a
          target=""
          className=""
          id="i053ng"
          href={`/`}
        >
          
    <div id="ikr9sk" className="">
    <>INICIO</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="igde3q"
          href={`/nosotros`}
        >
          
    <div id="igk7is" className="">
    <>CONÓCENOS</>
    </div>
    
        </a>
        
      <li className="linkshref " id="">
        
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
        <LoftyDropdownComponent
          id="isoayi"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="i536rc" className="gjs-dropdown-menu-trigger ">
<>UNETE
        </></div>

            </>
          }
          childrenHover={
            <>
              <div id="ifxvuy" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="i3hxau"
          href={`/socio_motorista`}
        >
          
    <div id="ip699g" className="">
    <>SOCIO MOTORISTA</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iufdal"
          href={`/publicidad`}
        >
          
    <div id="iaawbk" className="">
    <>PUBLICIDAD</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <LoftyDropdownComponent
          id="iq0mnk"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="iqbgg9" className="gjs-dropdown-menu-trigger ">
<>POLITICA
        </></div>

            </>
          }
          childrenHover={
            <>
              <div id="ifwcix" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="i61hhc"
          href={`/terminos_politicas`}
        >
          
    <div id="iw1wej" className="">
    <>TERMINOS & POLITICAS</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i4v96p"
          href={`/eliminar_cuenta`}
        >
          
    <div id="i6rlr2" className="">
    <>ELIMINAR CUENTA</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <LoftyDropdownComponent
          id="iwiyle"
          className="gjs-dropdown-menu-container "
          childrenShow={
            <>
              <div id="ip6o3a" className="gjs-dropdown-menu-trigger ">
<>RESPUESTAS
        </></div>

            </>
          }
          childrenHover={
            <>
              <div id="i6eavm" className="gjs-dropdown-menu-content " style={{display: 'block'}}>

        <a
          target=""
          className=""
          id="i3szb9"
          href={`/preguntas_respuestas`}
        >
          
    <div id="i84e89" className="">
    <>PREGUNTAS</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ir7afk"
          href="#"
        >
          
    <div id="i0l31h" className="">
    <>NOTICIAS !PRONTO¡</>
    </div>
    
        </a>
        </div>

            </>
          }
        />
        
        <a
          target=""
          className=""
          id="iznrni"
          href={`/contactanos`}
        >
          
    <div id="iera84" className="">
    <>CONTACTANOS</>
    </div>
    
        </a>
        
      <li className="linkshref " id="">
        
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ivzb1" className="">
      
      <div id="ij3mgp" className="">
      
      </div>
      
      <div id="ir5ohy" className="">
      
      <img
        className=""
        id="i1ij8f"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhb2n68h.png"
        alt="undefined"
      />
      
      <div className="" id="iypo7n">
        <>Opos... Page Not Found!</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="im6c9x">
        <>The page you looking for not found may be it not exist or removed.</>
      <br className="" id="" />
      
      <br className="" id="" />
      
      </div>
      
        <a
          target=""
          className=""
          id="i96vd"
          href={`/`}
        >
          
    <div id="iwe9i" className="">
    <>Go Back Home</>
    </div>
    
      <img
        className=""
        id="ikof4"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhb2tuew.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      <div id="izx98iy" className="">
      
        <a
          target=""
          className=""
          id="iqteqd"
          href="iiqnv8"
        >
          
      <img
        className=""
        id="ih8agp"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhar4q3t.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      <div id="i2wkyy" className="">
      
      <div id="idtdzs" className="">
      
      </div>
      
      <div id="ili81h" className="">
      
      <div id="in8v1v" className="">
      
      <img
        className=""
        id="ih7oge"
        src="https://assetsprojects.s3.amazonaws.com/404pziimh5eabfn.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="iabbo4">
        <>"Dicip Go, uniendo sueños y creando realidades."</>
      </div>
      
      <div id="i0aklm" className="">
      
      <div id="iiao7j" className="">
      
      <img
        className=""
        id="ihkvgk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhapqszf.png"
        alt="undefined"
      />
      
      </div>
      
        <a
          target="_blank"
          className=""
          id="i498ll"
          href="tel:+21236547898"
        >
          
    <div id="igphxl" className="">
    <>+(504)3334-8846</>
    </div>
    
        </a>
        
      </div>
      
      <div id="iq49kk" className="">
      
      <div id="iv4iez" className="">
      
      <img
        className=""
        id="in61um"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhapot9t.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="idnp2s">
        <>Tegucigalpa, Honduras</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      <div id="i9jhal" className="">
      
      <div id="ijhd05" className="">
      
      <img
        className=""
        id="i3rkkd"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhapr4sr.png"
        alt="undefined"
      />
      
      </div>
      
        <a
          target="_blank"
          className=""
          id="ikoyxp"
          href="mailto:info@example.com"
        >
          
    <div id="id135y" className="">
    <>info@dicipgo.com</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="itfo5z" className="">
      
      <div className="" id="ig6pu9">
        <>Links Web</>
      <br className="" id="" />
      
      </div>
      
      <div id="igw4ca" className="">
      
      <div id="igbbew" className="">
      
      </div>
      
      <div id="i7jg5x" className="">
      
      </div>
      
      <div id="i0cs3j" className="">
      
      </div>
      
      </div>
      
      <ul
        className=""
        id="i9jpdk"
        name="">
        
        <a
          target=""
          className=""
          id="ietl9z"
          href={`/`}
        >
          
    <div id="izfsug" className="">
    <>Inicio</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iqjy9k"
          href={`/nosotros`}
        >
          
    <div id="idaplq" className="">
    <>Nosotros</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iva6x9"
          href={`/socio_motorista`}
        >
          
    <div id="if5gpc" className="">
    <>Socios</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iv6xlh"
          href={`/publicidad`}
        >
          
    <div id="i9ee1g" className="">
    <>Publicidad</>
    </div>
    
        </a>
        
      </ul>
      
      </div>
      
      <div id="i0hajc" className="">
      
      <div className="" id="i1ry5b">
        <>Links Informativos</>
      <br className="" id="" />
      
      </div>
      
      <div id="indb5tt" className="">
      
      <div id="ijw2nr" className="">
      
      </div>
      
      <div id="i98yzz" className="">
      
      </div>
      
      <div id="ic6wg8w" className="">
      
      </div>
      
      </div>
      
      <ul
        className=""
        id="i0xug0v"
        name="">
        
        <a
          target=""
          className=""
          id="iglsjel"
          href={`/preguntas_respuestas`}
        >
          
    <div id="i5ifst9" className="">
    <>Preguntas frecuentes</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iqur2hg"
          href="#"
        >
          
    <div id="il6qymo" className="">
    <>Noticias</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i06brkc"
          href={`/contactanos`}
        >
          
    <div id="i52b9sc" className="">
    <>Contáctanos</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i9jwj9h"
          href={`/eliminar_cuenta`}
        >
          
    <div id="igvbgf6" className="">
    <>Eliminación de Cuentas</>
    </div>
    
        </a>
        
      </ul>
      
      </div>
      
      <div id="ibyhr7" className="">
      
      <div className="" id="i2gad2j">
        <>¡Suscríbete!</>
      <br className="" id="" />
      
      </div>
      
      <div id="iqf20lh" className="">
      
      <div id="iouqnbe" className="">
      
      </div>
      
      <div id="i0t7w7h" className="">
      
      </div>
      
      <div id="ijggbbk" className="">
      
      </div>
      
      </div>
      
      <div className="" id="ix1u5ym">
        <>Compártenos tu correo electrónico para que permanezcas informado sobre los últimos avances de Dicip Go.</>
      <br className="" id="" />
      
      </div>
      
        <div className="" id="i2lei25">
          
      <form
        id="iu2vtff"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await createsuscripcionop8hb({
						token: 'aasdas',
						emailad4px: e.target.emailad4px.value,
					});
					window.location.reload();
		} catch (error) {
					console.log(error);
				}
			}}
		
      >
        
      <div id="i4vo85m" className="">
      
      <br className="" id="" />
      
      <input
        name="emailad4px"
        type="text"
        placeholder="Email."
        className=""
        id="igp0qsh"
      />
      
      </div>
      
      <button
        type="submit"
        name=""
        id="id33zr1"
        className=""
        
      >
      
      <div id="iuqrm78" className="">
      <>SUSCRIBETE</>
      </div>
      
      <img
        className=""
        id="iupuxgq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhao37c4.png"
        alt="undefined"
      />
      
      </button>
      
      </form>
      
        </div>
        
      </div>
      
      </div>
      
      <div id="ia6axz" className="">
      
      <div className="" id="ikx7mga">
        <>© Copyright 2025 Dicip Go All Rights Reserved. Created by Go Data Monkey</>
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Perrorqmpd1);
  